import React from 'react'
import { useAppSelector } from '../../../hooks/hooks'
import { getSubAppById } from '../../../theme/subApps'

interface SubAppTileProps {
  size?: number
  onClick?: () => void
}

const SubAppTile: React.FC<SubAppTileProps> = ({ size = 40, onClick }) => {
  const moduleId = useAppSelector((state) => state.selectedModule.value)
  const subApp = getSubAppById(moduleId)

  return (
    <div
      className="gt-subapp-tile"
      role={onClick ? 'button' : undefined}
      tabIndex={onClick ? 0 : -1}
      onClick={onClick}
      onKeyDown={(e) => {
        if (onClick && (e.key === 'Enter' || e.key === ' ')) {
          e.preventDefault()
          onClick()
        }
      }}
      style={{
        width: size,
        height: size,
        background: subApp.color,
        cursor: onClick ? 'pointer' : 'default',
      }}
      aria-label={subApp.monogram}
    >
      {subApp.monogram}
    </div>
  )
}

export default SubAppTile
